import React from 'react'
import * as Component from './Menu.styles'
import { Overlay } from './partials'

import useScrollLock from 'hooks/useScrollLock'

const Menu = (props) => {
  const { children, className } = props

  const [open, setOpen] = React.useState(false)
  useScrollLock(open)

  const onOverlayClicked = () => {
    // Ignore the events not coming from the "Overlay"
    // if (e.target !== e.currentTarget) return

    setOpen(false)
  }

  return (
    <>
      <Overlay onOverlayClicked={ onOverlayClicked } open={ open }>
        <Component.Root
          aria-orientation='vertical'
          role='menu'
          className={ className }>
          {open && children}
          <Component.MenuButton
            onClick={ () => setOpen(!open) }
            open={ open }
            data-cy='mobile-menu-button'>
            <Component.MenuButtonIcon
              className={ open ? 'icon-f-cross' : 'icon-f-menu' }
              open={ open }
            />
          </Component.MenuButton>
        </Component.Root>
      </Overlay>
    </>
  )
}

export default Menu
